module.exports = __webpack_public_path__ + "static/media/elasticsearchlogo.066bcf7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/elasticsearchlogo.png
// module id = 829
// module chunks = 0